/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalImageMetadataPose } from './ExternalImageMetadataPose';
import {
    ExternalImageMetadataPoseFromJSON,
    ExternalImageMetadataPoseFromJSONTyped,
    ExternalImageMetadataPoseToJSON,
} from './ExternalImageMetadataPose';

/**
 * 
 * @export
 * @interface ExternalImageMetadata
 */
export interface ExternalImageMetadata {
    /**
     * 
     * @type {string}
     * @memberof ExternalImageMetadata
     */
    filename: string;
    /**
     * 
     * @type {ExternalImageMetadataPose}
     * @memberof ExternalImageMetadata
     */
    pose: ExternalImageMetadataPose;
    /**
     * 
     * @type {string}
     * @memberof ExternalImageMetadata
     */
    cameraType?: string;
}

/**
 * Check if a given object implements the ExternalImageMetadata interface.
 */
export function instanceOfExternalImageMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "pose" in value;

    return isInstance;
}

export function ExternalImageMetadataFromJSON(json: any): ExternalImageMetadata {
    return ExternalImageMetadataFromJSONTyped(json, false);
}

export function ExternalImageMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalImageMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'pose': ExternalImageMetadataPoseFromJSON(json['pose']),
        'cameraType': !exists(json, 'cameraType') ? undefined : json['cameraType'],
    };
}

export function ExternalImageMetadataToJSON(value?: ExternalImageMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filename': value.filename,
        'pose': ExternalImageMetadataPoseToJSON(value.pose),
        'cameraType': value.cameraType,
    };
}

